import { ActionState } from 'src/app/enums/action-state.enum';
import { DataAfterCloseImportExportModal } from 'src/app/models/dataAfterCloseImportExportModal';

export class DataAfterCloseStationsModal implements DataAfterCloseImportExportModal {

    uploadFileState: ActionState;
    downloadFileState: ActionState;

    constructor() {
        this.uploadFileState =  ActionState.READY;
        this.downloadFileState =  ActionState.READY;
    }

}
